/**
 * Botón de acceso al panel de gestión.
 *
 * Está oculto y aparece al acercar el mouse al borde superior (o al llegar con Tab, para
 * que sea usable con teclado). Así la vista de stream queda limpia para OBS y nadie
 * pulsa "entrar" por accidente, pero el acceso sigue ahí.
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';
import { useT } from '../lib/i18n.js';

export function PanelEntry(): JSX.Element {
  const t = useT();
  const navigate = useNavigate();
  const { me, status } = useAuth();
  const [revealed, setRevealed] = useState(false);

  const visible = revealed || status === 'loading';

  return (
    <>
      {/* Zona sensible: solo se activa con mouse cerca del borde superior. */}
      <div
        aria-hidden
        className="fixed inset-x-0 top-0 z-[var(--pit-z-sticky)] h-10"
        onMouseEnter={() => setRevealed(true)}
      />

      <div
        className={[
          'fixed inset-x-0 top-0 z-[var(--pit-z-sticky)] flex justify-end px-3 py-2',
          'transition-opacity duration-[var(--pit-duration-base)]',
          visible ? 'opacity-100' : 'pointer-events-none opacity-0',
        ].join(' ')}
        onMouseLeave={() => setRevealed(false)}
      >
        <button
          type="button"
          onClick={() => navigate(me ? '/pelea' : '/login')}
          onFocus={() => setRevealed(true)}
          onBlur={() => setRevealed(false)}
          className={[
            'pit-touch rounded-[var(--pit-radius-md)] border border-[var(--pit-border-subtle)]',
            'bg-[var(--pit-bg-sunken)]/95 px-3 py-1.5 backdrop-blur',
            'pit-mono text-[var(--pit-text-3xs)] uppercase tracking-[var(--pit-tracking-wider)]',
            'text-[var(--pit-text-secondary)] hover:border-[var(--pit-border-strong)] hover:text-[var(--pit-text-primary)]',
          ].join(' ')}
        >
          {me ? t('nav.panel') : t('nav.login')}
        </button>
      </div>
    </>
  );
}
